// src/components/PrivateRoute.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';

const PrivateRoute = ({ children, roles, allowCoordinator = false, allowInspector = false }) => {
  const { user, loading } = useContext(UserContext);

  console.log("🔍 [PrivateRoute] Sprawdzam użytkownika...");
  console.log("Loading:", loading);
  console.log("User:", user);

  if (loading) {
    console.log("⏳ Czekamy na załadowanie danych...");
    return <div>Ładowanie...</div>;
  }

  if (!user || !user.accessToken) {
    console.warn("❌ Użytkownik niezalogowany - przekierowanie do /login");
    return <Navigate to="/login" replace />;
  }

  // Sprawdź czy użytkownik ma odpowiednią rolę LUB jest coordinatorem/inspektorem
  const hasRoleAccess = roles && roles.includes(user.role);
  const hasCoordinatorAccess = allowCoordinator && user.isCoordinator;
  const hasInspectorAccess = allowInspector && user.inspector;

  if (roles && !hasRoleAccess && !hasCoordinatorAccess && !hasInspectorAccess) {
    console.warn("⛔ Brak uprawnień - przekierowanie do /");
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
